export const mockData = {
  navigation: [
    { id: 'story', label: 'Heritage' },
    { id: 'process', label: 'Method' },
    { id: 'flavours', label: 'Collection' },
    { id: 'contact', label: 'Contact' }
  ],
  hero: {
    title: 'KLOSTER LAKS',
    subtitle: 'Exquisite Norwegian cold-smoked salmon. Crafted for connoisseurs, trusted by the finest establishments.'
  },
  story: {
    title: 'Our Story',
    paragraphs: [
      'On the island of Halsnøy, where the North Sea meets ancient Norwegian tradition, we honor a craft passed down through centuries. Our cold smoking process follows the Augustinian monastic methods of the 10th century—patient, deliberate, reverent.',
      'Each fillet begins its journey on a bed of hand-harvested salt. Over the next ten hours, at temperatures never exceeding 25 degrees, oak and juniper smoke infuse every fiber with depth and character.',
      'We work with our hands because machines cannot discern perfection. We work slowly because excellence cannot be rushed. This is not production—it is preservation of an art form.'
    ]
  },
  process: [
    {
      title: 'Salting',
      description: 'First class fillets rest on hand-harvested sea salt, drawing moisture while infusing a balanced mineral complexity. The salt bed technique dates back to monastic traditions of preservation.'
    },
    {
      title: 'Marinating',
      description: 'Each fillet is hand-dried and marinated with carefully selected botanicals. The salmon rests for hours, allowing flavors to permeate every layer with precision and patience.'
    },
    {
      title: 'Smoking',
      description: 'Ten hours of cold smoking with Norwegian oak and wild juniper at precisely 25°C. The smoke whispers rather than shouts, creating layers of aromatic depth without overwhelming the delicate flesh.'
    },
    {
      title: 'Finishing',
      description: 'After smoking, the salmon enters a period of rest—allowing the smoke to settle, flavors to harmonize, and texture to achieve silk-like perfection. Only then is it prepared for your table.'
    }
  ],
  flavours: [
    {
      name: 'Natural',
      description: 'Pure Norwegian salmon, cold-smoked with oak and juniper. No embellishment, no distraction—just the essential expression of our craft and the sea.',
      notes: 'Pure & Timeless',
      icon: 'fish'
    },
    {
      name: 'Bareksten Gin',
      description: 'Marinated with the world-renowned Bareksten botanical gin. Juniper, citrus, and herbal notes intertwine with smoke, creating a sophisticated harmony of land and sea.',
      notes: 'Botanical & Refined',
      icon: 'wine'
    },
    {
      name: 'Juniper',
      description: 'Infused with wild Norwegian juniper berries. Piney aromatics and subtle pepperiness complement the natural sweetness of the salmon, evoking the coastal forests of our homeland.',
      notes: 'Forest & Coastal',
      icon: 'leaf'
    },
    {
      name: 'Chili',
      description: 'A measured warmth from carefully selected chilies adds depth without dominance. The heat enhances rather than overwhelms, revealing new dimensions in the salmon with each taste.',
      notes: 'Warm & Complex',
      icon: 'flame'
    }
  ],
  testimonials: [
    {
      quote: 'The quality is exceptional. You can taste the craftsmanship in every slice.',
      name: 'Erik Hansen',
      role: 'Restaurant Chef, Bergen'
    },
    {
      quote: 'The Bareksten Gin flavor is absolutely divine. It\'s become our go-to for special occasions.',
      name: 'Sofie Larsen',
      role: 'Food Blogger'
    },
    {
      quote: 'Traditional methods meet premium quality. Kloster Laks has set a new standard.',
      name: 'Magnus Olsen',
      role: 'Culinary Director'
    }
  ],
  trustedBy: [
    {
      name: 'Manchester City FC',
      detail: 'Official supplier'
    },
    {
      name: 'Erling Haaland',
      detail: 'Personal choice'
    }
  ],
  contacts: [
    {
      name: 'Rune Eide',
      role: 'Founder & Manager',
      phone: '+47 480 09 519',
      email: 'rune@klosterlaks.no'
    },
    {
      name: 'Madeleine E. Aasen',
      role: 'Creative Manager',
      phone: '+47 977 40802',
      email: 'madeleine@klosterlaks.no'
    }
  ]
};